import React, { Component } from 'react';
import { isApp } from '../../../utils';
import './mobile_stripe.scss';

class MobileStripe extends Component {
    render() {
        if (isApp()) {
            return (
                <div className='mobile-stripe'>
                    <span>PA LOTTERY ONLINE</span>
                </div>
            );
        } else {
            return <></>;
        }
    }
}

export default MobileStripe;
